module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Acknowledgements-rw",
    attrs: {
      "epub:type": "frontmatter",
      "id": "Acknowledgements1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block3"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p8"
    }
  }, [_vm._v("This story started out as a nebulous idea about a child who didn’t like Christmas. That idea took me to the Internet, where I researched the topic. And that led me to many, many resources about autism and Asperger’s syndrome. I wasn’t so sure I wanted to tackle that issue, but I emailed my good friend Caroline Bradley, who is the mother of a wonderful son named Alex who is on the spectrum. She had a lot to say about Aperger’s kids: what it means to be the mother of a child with special needs, and the difficulties of negotiating the holidays. So first and foremost I would like to give Caroline my deepest and most heartfelt thanks for her willingness to share with me, for her encouragement, and for being the incredible mother that she is. I could not have written this story without her help.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("I’d also like to thank my fabulous critique partners, Carol Hayes and J. Keely Thrall, who, as always, helped me find the beating heart in the center of this story. Thanks also to the wonderful ladies of the Last Chance Book Club, who persuaded me that there ought to be one more Last Chance story with some angels. And, last but not least, I’d like to thank my wonderful agent, Elaine English, and my amazing editor, Alex Logan, for all they do to keep me heading in a straight line.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d87e4df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s004-Acknowledgements-01.vue
// module id = 69
// module chunks = 0